import angular from 'angular';
import DropdownComponent from './dropdown.ng1.component';

const DropdownModule = angular
    .module('control-room.commons.basic.components.dropdown', ['ui.bootstrap.dropdown', 'ui.validate'])
    .component('crDropdown', DropdownComponent);

export default DropdownModule;
